import React from 'react';
import { Box, Typography, Switch } from '@mui/material';
import { styled } from '@mui/material/styles';
import ScienceIcon from '@mui/icons-material/Science';

const BottomBanner = styled(Box)(({ theme }) => ({
  position: 'fixed',
  bottom: 0,
  left: 0,
  right: 0,
  zIndex: 1200,
  backgroundColor: 'rgba(255, 255, 255, 0.98)',
  backdropFilter: 'blur(12px)',
  borderTop: '1px solid rgba(0, 0, 0, 0.08)',
  padding: '12px 24px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '24px',
  transition: 'all 0.3s ease',
  [theme.breakpoints.down('sm')]: {
    padding: '10px 16px',
    gap: '16px',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
  },
}));

const InfoSection = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: '10px',
});

const ControlSection = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: '12px',
});

const StyledSwitch = styled(Switch)(({ theme }) => ({
  '& .MuiSwitch-switchBase.Mui-checked': {
    color: '#1f2937',
  },
  '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
    backgroundColor: '#374151',
  },
  '& .MuiSwitch-track': {
    backgroundColor: '#cbd5e1',
  },
}));

const StatusBadge = styled(Box)(({ isEnabled }) => ({
  padding: '6px 14px',
  borderRadius: '6px',
  fontSize: '0.75rem',
  fontWeight: 600,
  letterSpacing: '0.5px',
  backgroundColor: isEnabled
    ? 'rgba(52, 211, 153, 0.15)'
    : 'rgba(248, 113, 113, 0.15)',
  color: isEnabled ? '#34d399' : '#f87171',
  border: `1px solid ${isEnabled ? 'rgba(52, 211, 153, 0.3)' : 'rgba(248, 113, 113, 0.3)'}`,
  transition: 'all 0.2s ease',
  textTransform: 'uppercase',
}));

const Divider = styled(Box)(({ theme }) => ({
  width: '1px',
  height: '24px',
  backgroundColor: 'rgba(0, 0, 0, 0.1)',
  [theme.breakpoints.down('sm')]: {
    display: 'none',
  },
}));

/**
 * TestModeControls Component
 * Bottom banner for test mode validation controls
 */
const TestModeControls = ({ isValidationEnabled, onValidationToggle }) => {
  return (
    <BottomBanner>
      <InfoSection>
        <ScienceIcon
          sx={{
            color: '#1f2937',
            fontSize: 20,
          }}
        />
        <Typography
          variant="body2"
          sx={{
            fontWeight: 600,
            color: '#1e293b',
            fontSize: '0.875rem',
            display: { xs: 'none', sm: 'block' },
          }}
        >
          Test Mode
        </Typography>
      </InfoSection>

      <Divider />

      <ControlSection>
        <Typography
          variant="body2"
          sx={{
            fontWeight: 500,
            color: '#475569',
            fontSize: '0.813rem',
          }}
        >
          Validation
        </Typography>
        <StyledSwitch
          checked={isValidationEnabled}
          onChange={(e) => onValidationToggle(e.target.checked)}
          size="small"
        />
        <StatusBadge isEnabled={isValidationEnabled}>
          {isValidationEnabled ? 'ON' : 'OFF'}
        </StatusBadge>
      </ControlSection>
    </BottomBanner>
  );
};

export default TestModeControls;
